import { B_PRIORITIES, D_PRIORITIES, CandidatePriority } from '@pflegia/types/api/candidate/candidate-priority';

import { getHighestPriorityJobTitles } from './get-highest-priority-job-titles';

type JobTitleWithOptionalTrackingPriority = {
  trackingPriority?: CandidatePriority | null;
};

export const QUICK_SIGNUP_ELIGIBLE_TRACKING_PRIORITIES = [CandidatePriority.A, ...B_PRIORITIES, ...D_PRIORITIES] as const;

export const isQuickSignupEligibleTrackingPriority = (trackingPriority?: CandidatePriority | null): boolean =>
  Boolean(trackingPriority && (QUICK_SIGNUP_ELIGIBLE_TRACKING_PRIORITIES as readonly CandidatePriority[]).includes(trackingPriority));

export const getHighestQuickSignupTrackingPriority = (
  jobTitles: readonly JobTitleWithOptionalTrackingPriority[],
): CandidatePriority | null => {
  const jobTitlesWithPriority = jobTitles.filter((jobTitle): jobTitle is { trackingPriority: CandidatePriority } =>
    Boolean(jobTitle.trackingPriority),
  );

  return getHighestPriorityJobTitles(jobTitlesWithPriority)[0]?.trackingPriority ?? null;
};

export const areJobTitlesEligibleForQuickSignup = (jobTitles: readonly JobTitleWithOptionalTrackingPriority[]): boolean =>
  isQuickSignupEligibleTrackingPriority(getHighestQuickSignupTrackingPriority(jobTitles));

const QUICK_SIGNUP_CANDIDATE_PRIORITY: { [key in CandidatePriority]?: CandidatePriority } = {
  [CandidatePriority.A]: CandidatePriority.A,
  [CandidatePriority.B]: CandidatePriority.B1,
  [CandidatePriority.D]: CandidatePriority.D2,
  [CandidatePriority.E]: CandidatePriority.E,
  [CandidatePriority.F]: CandidatePriority.F,
};

export const getQuickSignupCandidatePriority = (trackingPriority?: CandidatePriority | null): CandidatePriority | null =>
  trackingPriority ? (QUICK_SIGNUP_CANDIDATE_PRIORITY[trackingPriority[0] as CandidatePriority] ?? null) : null;
